(() => {
  const GRAMS_PER_LB = 453.592;
  const CART_MUTATION_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  let refreshTimer = null;

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    // small delay lets Shopify cart settle after mutation
    refreshTimer = setTimeout(refreshWeight, 120);
  }

  function isCartMutation(url, method = 'GET') {
    const m = String(method).toUpperCase();
    if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(m)) return false;
    return CART_MUTATION_PATHS.some((p) => String(url || '').includes(p));
  }

  async function refreshWeight() {
    const el = document.querySelector('.lbs-span');
    if (!el) return;

    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const lbs = ((cart.total_weight || 0) / GRAMS_PER_LB).toFixed(1);
      el.textContent = `${lbs} lbs`;
    } catch (_) {
      // no-op
    }
  }

  // Initial + passive refreshes
  document.addEventListener('DOMContentLoaded', refreshWeight);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshWeight();
  });
  window.addEventListener('focus', refreshWeight);

  // Fetch interception (Ajax cart updates)
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url =
      typeof input === 'string'
        ? input
        : input && typeof input.url === 'string'
          ? input.url
          : '';
    const method =
      (init && init.method) ||
      (input && typeof input !== 'string' && input.method) ||
      'GET';

    const response = await originalFetch.apply(this, arguments);

    if (response && response.ok && isCartMutation(url, method)) {
      scheduleRefresh();
    }

    return response;
  };

  // XHR interception (some themes/apps still use XHR)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartMethod = method;
    this._cartUrl = url;
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300 && isCartMutation(this._cartUrl, this._cartMethod)) {
        scheduleRefresh();
      }
    });
    return originalSend.apply(this, arguments);
  };
})();